import React, { useState } from 'react';
import { useTheme } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    CreateStockCardCategoryMutationVariables,
    useCreateStockCardCategoryMutation,
} from '../../../../generated/graphql';
import { STOCK_CARD_CATEGORIES } from '../../graphql/queries';
import { routePaths } from '../../../../routePaths';
import { FullScreenDialog } from '../../../../ui-kit';
import StockCardCategoryForm, { StockCardCategoryFormValues } from './WarehouseCategoryForm';

const CreateWarehouseCategoryForm = () => {
    const [isDialogOpened, setIsDialogOpened] = useState(true);
    const history = useHistory();
    const theme = useTheme();

    const onClose = () => {
        setIsDialogOpened(false);
        setTimeout(() => history.push(routePaths.warehouseCategories), theme.transitions.duration.leavingScreen);
    };

    const [runMutation] = useCreateStockCardCategoryMutation({ refetchQueries: [{ query: STOCK_CARD_CATEGORIES }] });
    const onSubmit = async ({ name }: StockCardCategoryFormValues) => {
        const variables: CreateStockCardCategoryMutationVariables = {
            data: {
                name,
            }
        };
        await runMutation({ variables });
        onClose();
    };

    const { t } = useTranslation();


    return (
        <FullScreenDialog isOpened={isDialogOpened}>
            <StockCardCategoryForm
                buttonText={t('Create')}
                dialogName={t('New warehouse category')}
                onClose={onClose}
                onSubmit={onSubmit}
            />
        </FullScreenDialog>
    );
};

export default CreateWarehouseCategoryForm;
